module.exports = __webpack_public_path__ + "static/media/0022_IMG_LES_MURS_METRO_DIAMANTO_BRILLANT_PIRITE_HORIZONTALE.1eb6d5f9.png";